import React from 'react';

import { Modal } from '../kit.js';
import { ScenePicker } from './scenes.js';

import { ReactComponent as Home } from '../../media/images/svg/grid_view.svg';

/* ─────────────────────────────────────────────────────────────
   The quick menu behind the bar's menu glyph.

   The rail is the real navigation, but at nineteen destinations most
   of it is off the edge of a phone, so this lays the whole side out
   at once. It also carries the scenes, because on a phone the Scenes
   button is one of the things the bar gives up for room.

   Staff already have their home (Overview) at the head of their list;
   the resident welcome screen is not a destination, so it gets a tile
   of its own.
   ───────────────────────────────────────────────────────────── */
export function QuickMenu({ open, onClose, mode, items, onHome, onGo, onSwitch, scene, applying, onScene }) {
    const staff = mode === 'staff';
    const pick = fn => () => { onClose(); fn(); };

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="lg"
            eyebrow={staff ? 'Staff menu' : 'Resident menu'}
            title={staff ? 'Building operations' : 'Everything in the building'}
            actions={
                <button type="button" className="btn btn-outline-light" onClick={pick(onSwitch)}>
                    {staff ? 'Switch to the resident view' : 'Switch to the staff view'}
                </button>
            }
        >
            <div className="qmenu__grid">
                {!staff && (
                    <button type="button" className="qmenu__item qmenu__item--home" onClick={pick(onHome)}>
                        <Home aria-hidden="true" />
                        <span>Home</span>
                    </button>
                )}
                {items.map(({ screen, label, Icon }) => (
                    <button type="button" className="qmenu__item" key={screen} onClick={pick(() => onGo(screen))}>
                        <Icon aria-hidden="true" />
                        <span>{label}</span>
                    </button>
                ))}
            </div>

            <div className="qmenu__scenes">
                <span className="tiles__label">Scenes</span>
                <ScenePicker compact active={scene} applying={applying} onApply={onScene} />
            </div>
        </Modal>
    );
}
